import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers';
import promise from 'redux-promise';

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

// Middleware you want to use in production:
const enhancer = composeEnhancers(applyMiddleware(promise));

export default function configureStore(initialState) {

	// Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
	// See https://github.com/rackt/redux/releases/tag/v3.1.0
	return createStore(rootReducer, initialState, enhancer);
};



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.js
 **/